import api from '../config/api';

// API temel URL
const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/api'  // This will use the current domain (mrbrowncase.com) and be rewritten by Vercel
  : 'http://localhost:3001/api';

// Token'ı kontrol et
export const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  return token && user;
};

// Mevcut kullanıcıyı getir
export const getCurrentUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

// Çıkış yap
export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  // Misafir verilerini de temizle (isteğe bağlı)
  // clearGuestData(); // Eğer logout sonrası misafir verilerini korumak istiyorsan bu satırı kapatabilirsin
  window.location.href = '/login';
};

export const login = async (email, password) => {
  try {
    // Eğer zaten giriş yapılmışsa, ana sayfaya yönlendir
    if (isAuthenticated()) {
      window.location.href = '/';
      return;
    }

    const response = await fetch(`${API_BASE_URL}/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Giriş yapılırken bir hata oluştu');
    }

    // Token'ı localStorage'a kaydet
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data.user));

    // Misafir verilerini aktar (async olarak, hata olursa da devam et)
    try {
      await transferGuestData();
    } catch (transferError) {
      console.warn('Misafir verileri aktarılırken hata oluştu (giriş başarılı):', transferError.message);
    }

    return data;
  } catch (error) {
    throw error;
  }
};

export const register = async (userData) => {
  try {
    // Eğer zaten giriş yapılmışsa, ana sayfaya yönlendir
    if (isAuthenticated()) {
      window.location.href = '/';
      return;
    }

    const response = await fetch(`${API_BASE_URL}/auth/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userData),
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Kayıt olurken bir hata oluştu');
    }

    // Token'ı localStorage'a kaydet
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data.user));

    // Misafir verilerini aktar (async olarak, hata olursa da devam et)
    try {
      await transferGuestData();
    } catch (transferError) {
      console.warn('Misafir verileri aktarılırken hata oluştu (kayıt başarılı):', transferError.message);
    }

    return data;
  } catch (error) {
    throw error;
  }
};

// Şifre sıfırlama isteği gönder
export const forgotPassword = async (email) => {
  try {
    // Axios kullanarak istek gönder (API tarafında JSON olarak işlenir)
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  } catch (error) {
    // Hata işleme
    if (error.response) {
      // Sunucu yanıtı ile dönen hata
      throw new Error(error.response.data.error || 'Şifre sıfırlama isteği gönderilirken bir hata oluştu');
    } else if (error.request) {
      // İstek yapıldı ama yanıt alınamadı
      console.error('Sunucudan yanıt alınamadı:', error.request);
      throw new Error('Sunucu yanıt vermiyor. Lütfen daha sonra tekrar deneyin.');
    } else {
      // İstek yapılırken bir hata oluştu
      console.error('İstek hatası:', error.message);
      throw new Error('Şifre sıfırlama isteği gönderilemedi. Lütfen tekrar deneyin.');
    }
  }
};

// Şifre sıfırlama
export const resetPassword = async (token, password) => {
  try {
    const response = await api.post('/auth/reset-password', { token, password });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.error || 'Şifre sıfırlanırken bir hata oluştu');
    } else if (error.request) {
      console.error('Sunucudan yanıt alınamadı:', error.request);
      throw new Error('Sunucu yanıt vermiyor. Lütfen daha sonra tekrar deneyin.');
    } else {
      console.error('İstek hatası:', error.message);
      throw new Error('Şifre sıfırlama isteği gönderilemedi. Lütfen tekrar deneyin.');
    }
  }
};

// API istekleri için yardımcı fonksiyon
export const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

// Misafir verilerini login sonrası aktar
export const transferGuestData = async () => {
  try {
    // LocalStorage'dan misafir verilerini al
    const guestCart = localStorage.getItem('guestCart');
    const guestFavorites = localStorage.getItem('guestFavorites');
    
    let cart = [];
    let favorites = [];
    
    
    // Sepet verilerini parse et
    if (guestCart) {
      try {
        const parsedCart = JSON.parse(guestCart);
        
        if (Array.isArray(parsedCart)) {
          // LocalStorage formatını backend formatına dönüştür
          cart = parsedCart.map(item => {
            // selectedColor formatını düzelt
            let selectedColor = null;
            if (item.selectedColor) {
              if (typeof item.selectedColor === 'string') {
                selectedColor = item.selectedColor;
              } else if (item.selectedColor.name) {
                selectedColor = item.selectedColor.name;
              } else if (item.selectedColor.code) {
                selectedColor = item.selectedColor.code;
              }
            } else if (item.selected_color) {
              selectedColor = item.selected_color;
            }

            const phoneModelId = item.phone_model_id || item.phoneModelId || null;
            const colorId = item.color_id || item.colorId || null;
            
            return {
              productId: item.product_id || item.productId,
              quantity: item.quantity || 1,
              designId: item.design_id || item.designId || null,
              selectedColor: selectedColor,
              phoneModelId: phoneModelId,
              colorId: colorId
            };
          });
        }
      } catch (e) {
        console.warn('Guest cart data parsing error:', e);
      }
    }
    
    // Favori verilerini parse et
    if (guestFavorites) {
      try {
        const parsedFavorites = JSON.parse(guestFavorites);
        
        if (Array.isArray(parsedFavorites)) {
          // Favoriler için tüm bilgileri al (product_id ve phone_models dahil)
          favorites = parsedFavorites.map(item => {
            if (typeof item === 'number') {
              // Sadece ID ise, minimal format oluştur
              return { product_id: item, phone_models: [] };
            } else if (item.product_id) {
              // Object içindeki product_id
              return {
                product_id: item.product_id,
                phone_models: item.phone_models || []
              };
            } else if (item.product && item.product.id) {
              // Nested product object içindeki id
              return {
                product_id: item.product.id,
                phone_models: item.phone_models || item.product.phone_models || []
              };
            }
            return null;
          }).filter(item => item !== null);
        }
      } catch (e) {
        console.warn('Guest favorites data parsing error:', e);
      }
    }
    
    // Eğer transfer edilecek veri yoksa işlemi durdur
    if (cart.length === 0 && favorites.length === 0) {
      return { success: true, data: { transferred: { cart: { added: 0, skipped: 0 }, favorites: { added: 0, skipped: 0 } } } };
    }
    
    // Backend'e transfer isteği gönder
    const response = await api.post('/auth/transfer-guest-data', {
      cart,
      favorites
    });
    
    if (response.data.success) {
      // Transfer başarılıysa misafir verilerini temizle
      localStorage.removeItem('guestCart');
      localStorage.removeItem('guestFavorites');
      
      return response.data;
    } else {
      throw new Error(response.data.message || 'Transfer işlemi başarısız');
    }
    
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.message || 'Misafir verileri aktarılırken bir hata oluştu');
    } else {
      throw new Error('Misafir verileri aktarılırken bir hata oluştu');
    }
  }
};

// LocalStorage'dan misafir verilerini temizle (logout sırasında)
export const clearGuestData = () => {
  localStorage.removeItem('guestCart');
  localStorage.removeItem('guestFavorites');
};